var STATES = {
    HOME: 'home',
    ENTERPRISE_SIGNUP: 'enterprise_signup', // 企業用戶landing page

    ALL_PRODUCT: 'all_product', // 所有商品
    PRODUCT_LIST: 'product_list', // 商品列表
    PRODUCT: 'product', // 商品頁面
    COMPLEX_PDT: 'complex_pdt', // 複合商品

    // PAYMENT: 'payment', // 結帳畫面（訂單詳情）
    ORDER: 'order', // 訂單詳情
    ORDER_LIST: 'orderlist', // 我的訂單
    ORDER_LIST_ALL: 'orderlist.all', // 我的訂單（所有
    ORDER_LIST_PAY: 'orderlist.pay', // 我的訂單（待付款
    ORDER_LIST_DISCARD: 'orderlist.discard', // 我的訂單（作廢
    ORDER_LIST_SUCCESS: 'orderlist.success', // 我的訂單（完成

    CART: 'cart',
    OTHER: 'other', // 會員相關頁面
    ORDER_HISTORY: 'order_history', // 訂購紀錄
    PAYMENT_RESULT: 'payment_result',  // 結帳結果畫面
    PAYMENT_SINOPACCREDITCARD: 'payment_sinopaccreditcard', // 永豐信用卡結帳畫面
    PAYMENT_POINT: 'payment_point', // 預儲點數結帳畫面
    PAYMENT_SINOPACATM: 'payment_sinopacatm', // 永豐ATM結帳畫面
    PAYMENT_OUTWARDREMITTANCE: 'payment_outwardremittance', // 金融機構臨櫃匯款畫面
    PAYMENT_SPGATEWAYCVS: 'payment_spgatewaycvs', // 智付通超商付款畫面
    PAYMENT_MONTHLY: 'payment_monthly', // 月結付款畫面

    EXTRAFEE_PAYMENT_RESULT: 'extrafee_payment_result', // 補收款 結帳結果畫面
    EXTRAFEE_PAYMENT_SINOPACATM: 'extrafee_payment_sinopacatm', // 補收款 永豐ATM結帳畫面
    EXTRAFEE_PAYMENT_SINOPACCREDITCARD: 'extrafee_payment_sinopaccreditcard', // 補收款 永豐信用卡結帳畫面
    EXTRAFEE_PAYMENT_POINT: 'extrafee_payment_point', // 補收款 預儲點數結帳畫面
    EXTRAFEE_PAYMENT_OUTWARDREMITTANCE: 'extrafee_payment_outwardremittance', // 補收款 金融機構臨櫃匯款畫面
    EXTRAFEE_PAYMENT_SPGATEWAYCVS: 'extrafee_payment_spgatewaycvs', // 補收款 智付通超商付款畫面
    EXTRAFEE_PAYMENT_MONTHLY: 'extrafee_payment_monthly', // 補收款 月結付款畫面
    
    FAQ: 'faq',
    FAQ_CONTENT: 'faq.content',
    SYSTEM_MESSAGE: 'system_message', // 系統通知

    BEGINNERS_GUIDE: 'beginners_guide', //新手指南
    PROFILE: 'profile', // 個人資訊頁面
    CHANGE_PWD: 'change_pwd', // 更改密碼頁面
    FAVORITE_ADDRESS: 'favorite_address', // 常用地址
    ABOUT: 'about', // 關於inif印衣服
    CONTACT: 'contact', // 聯絡客服

    SEARCH_PDT: 'search_pdt',  // 搜尋產品
    SEARCH_FAQ: 'search_faq', // 搜尋 FAQ

    POINTS_MONTHLY_INTRODUCTION: 'points_monthly_introduction', // 月節landing page

    MAIL_IDENTIFY: 'mail_identify', // Email 認證頁
    BUSINESSMEMBER_MAIL_IDENTIFY: 'businessmember_mail_identify', // 企業用戶 Email 認證頁
    RESET_PASSWORD: 'reset_password', // 重設密碼頁面
    CHANGE_EMAIL: 'changeemail', // 更換Email頁面
    NATIVE_LOGIN_MODAL: 'nativeLoginModal', // iOS/Android原生登入畫面
    RESET_BUSINESS_MEMBER_PASSWORD: 'reset_business_member_password', // 重設企業用戶密碼頁面

    // CMS 相關
    DESIGN_RSC: 'design_rsc',
    BLOG_LIST: 'design_rsc.blog_list',
    RESOURCE_LIST: 'design_rsc.resource_list',
    DESIGNER_LIST: 'design_rsc.designer_list',
    PROJECT_LIST: 'design_rsc.project_list',

    BLOG_POST: 'blog_post',
    PROJECT_POST: 'project_post',
    DESIGNER: 'designer',

    FB_LOGIN_SUCCESS: 'fb_login_success',
};

// 明確發布 route state 常數給 downstream scripts 讀取。理由同 js/app.js。
window.STATES = STATES;

var app = angular.module('InifECMobileApp', [
    'InifECShared', // 跨 module 共用檔的註冊目標，見 js/shared.js
    'ui.router',
    'ngStorage',
    'facebook',
    'facebook.config',
    'ngFileUpload',
    'ngEnter',
    'infinite-scroll',
    'ngScrollbar',
    'ct.ui.router.extras',
    'ngCookies',
    'ngModal',
    'ngDropdown',
    'angucomplete',
    'angulartics', // for analytics
    'angulartics.google.analytics', // for google analytics,
    'wu.masonry',
    'cupoy.draft',
])

.config(['$sceProvider', '$stateProvider', '$urlRouterProvider', '$locationProvider', '$animateProvider', '$stickyStateProvider',
    function($sceProvider, $stateProvider, $urlRouterProvider, $locationProvider, $animateProvider, $stickyStateProvider) {
        
        // 移除angular的#符號，使用restURL呈現，需要搭配後端支援，後端部分請查看 SEOPageFilter
        $locationProvider.html5Mode(true);
        // 取消ng-animate功能，若是有ng-animate的class name才會有ng-animate的效果
        $animateProvider.classNameFilter(/angular-animate/);
        // ng-bind-html word
        $sceProvider.enabled(false);
        // Start Page
        $urlRouterProvider.otherwise("/");

        $stickyStateProvider.enableDebug(false);

        // ui view setting
        $stateProvider

        .state(STATES.HOME, {
            url: "/?useNativeLoginModal",
            views: {
                'home@': {
                    templateUrl: "mobile/partials/home.html",
                    controller: 'HomeController',
                }
            },        
            deepStateRedirect: true,
            sticky: true
        })

        // .state(STATES.ENTERPRISE_SIGNUP, {
        //     url: "/enterprise-signup",
        //     views: {
        //         'full_other@': {
        //             templateUrl: "mobile/partials/enterprise_signup.html",
        //             controller: 'EnterpriseSignupController',
        //         }
        //     }
        // })

        .state(STATES.ALL_PRODUCT, {
            url: "/all?mainPdtClass",
            views: {
                'all_product@': {
                    templateUrl: "mobile/partials/all_product.html",
                    controller: "AllProductController",
                }
            },
            deepStateRedirect: true,
            sticky: true,
        })

        .state(STATES.PRODUCT_LIST, {
            url: "/class/:class",
            views: {
                'all_product@': {
                    templateUrl: "mobile/partials/all_product.html",
                    controller: 'AllProductController',
                },
            },
            deepStateRedirect: true,
            sticky: true
        })

        .state(STATES.PRODUCT, {
            url: "/product/:productid",
            views: {
                'full_product@': {
                    templateUrl: "mobile/partials/product.html",
                    controller: 'ProductController',
                }
            }
        })

        .state(STATES.COMPLEX_PDT, {
            url: "/complexpdt/:complexid/:productid",
            views: {
                'full_product@': {
                    templateUrl: "mobile/partials/complex_pdt.html",
                    controller: 'ComplexPdtController',
                }
            }
        })

        .state(STATES.ORDER, {
            url: "/payment/:orderid", // url網址跟web版一致
            views: {
                'full_order@': {
                    templateUrl: "mobile/partials/order.html",
                    controller: 'OrderController',
                }
            }
        })

        .state(STATES.ORDER_LIST, {
            url: "/member/orderlist?useNativeLoginModal",
            views: {
                'orderlist@': {
                    templateUrl: "mobile/partials/order_list.html",
                    controller: 'OrderListController',
                }
            },
            deepStateRedirect: true,
            sticky: true
        })
            .state(STATES.ORDER_LIST_ALL, {
                url: "/all",
                views: {
                    'subcontent@orderlist': {
                        templateUrl: "mobile/partials/order_list_content.html",
                        controller: 'OrderListAllController',
                    }
                }
            })
            .state(STATES.ORDER_LIST_PAY, {
                url: "/pay",
                views: {
                    'subcontent@orderlist': {
                        templateUrl: "mobile/partials/order_list_content.html",
                        controller: 'OrderListPayController',
                    }
                }
            })
            .state(STATES.ORDER_LIST_DISCARD, {
                url: "/discard",
                views: {
                    'subcontent@orderlist': {
                        templateUrl: "mobile/partials/order_list_content.html",
                        controller: 'OrderListDiscardController',
                    }
                }
            })
            .state(STATES.ORDER_LIST_SUCCESS, {
                url: "/success",
                views: {
                    'subcontent@orderlist': {
                        templateUrl: "mobile/partials/order_list_content.html",
                        controller: 'OrderListSuccessController',
                    }
                }
            })

        .state(STATES.CART, {
            url: "/cart?useNativeLoginModal",
            views: {
                'cart@': {
                    templateUrl: "mobile/partials/cart.html",
                    controller: 'CartController',
                }
            }
        })

        //
        .state(STATES.OTHER, {
            url: "/other?useNativeLoginModal",
            views: {
                'other@': {
                    templateUrl: "mobile/partials/other.html",
                    controller: 'OtherController',
                }
            },
            deepStateRedirect: true,
            sticky: true
        })  
        .state(STATES.NATIVE_LOGIN_MODAL, {
            url: "/nativeLogin/:state",
            views: {
                'native_login@': {
                    // templateUrl: "mobile/partials/other.html",
                    template: "<div></div>",
                    controller: 'NativeLoginController',
                }
            },
            params: {
                useNativeLoginModal: true
            },
            deepStateRedirect: true,
            sticky: true
        })        

        .state(STATES.ORDER_HISTORY, {
            url: "/member/order/history",
            views: {
                'other@': {
                    templateUrl: "mobile/partials/order_history.html",
                    controller: 'OrderHistoryController',
                }
            }
        })

        .state(STATES.SYSTEM_MESSAGE, {
            url: "/member/system-message",
            views: {
                'other@': {
                    templateUrl: "mobile/partials/system_message.html",
                    controller: 'SystemMessageController',
                }
            }
        })

        // .state(STATES.BEGINNERS_GUIDE, {
        //     url: "/guide/process",
        //     views: {
        //         'full_other@': {
        //             templateUrl: "mobile/partials/beginners_guide.html",
        //             controller: 'BeginnersGuideController',
        //         }
        //     }
        // })

        .state(STATES.ABOUT, {
            url: "/about",
            views: {
                'other@': {
                    templateUrl: "mobile/partials/about.html",
                }
            }
        })

        .state(STATES.CONTACT, {
            url: "/contact",
            views: {
                'other@': {
                    templateUrl: "mobile/partials/contact.html",
                }
            }
        })

        .state(STATES.PROFILE, {
            url: "/member/profile",
            views: {
                'other@': {
                    templateUrl: "mobile/partials/profile.html",
                    controller: 'ProfileController',
                }
            }
        })

        .state(STATES.CHANGE_PWD, {
            url: "/member/change-pwd",
            views: {
                'other@': {
                    templateUrl: "mobile/partials/change_pwd.html",
                    controller: 'ChangePwdController',
                }
            }
        })

        .state(STATES.FAVORITE_ADDRESS, {
            url: "/member/favorite-address",
            views: {
                'full_other@': {
                    templateUrl: "mobile/partials/favorite_address.html",
                    controller: 'FavoriteAddressController',
                }
            }
        })

        .state(STATES.FAQ, {
            url: "/faq",
            views: {
                'faq@': {
                    templateUrl: "mobile/partials/faq.html",
                    controller: 'FAQController',
                }
            },
            //deepStateRedirect: true,
            //sticky: true
        })

        .state(STATES.FAQ_CONTENT, {
            url: "/:mainfaqid/:subfaqid?faqid",
            views: {
                'faq_content@': {
                    templateUrl: "mobile/partials/faq_content.html",
                    controller: 'FAQContentController',
                }
            },
            params: {
                'faqid': '',
            }
       })

        .state(STATES.SEARCH_PDT, {
             url: "/search/pdt?keyword",
             views: {
                 'search@': {
                     templateUrl: "mobile/partials/search_product.html",
                     controller: 'SearchProductController',
                 }
             },
        })
        .state(STATES.SEARCH_FAQ, {
             url: "/search/faq?keyword",
             views: {
                 'search@': {
                     templateUrl: "mobile/partials/search_faq.html",
                     controller: 'SearchFAQController',
                 }
             },
        })

        .state(STATES.POINTS_MONTHLY_INTRODUCTION, {
             url: "/points-monthly-introduction",
             views: {
                 'full_other@': {
                     templateUrl: "mobile/partials/points_monthly_introduction.html",
                 },
             },
        })

        // 重設密碼
        .state(STATES.RESET_PASSWORD,{
            url: "/resetpasswd/:email/:token",
            views: {
                'other@': {
                    templateUrl: "mobile/partials/other.html",
                    controller: 'ResetPasswordController',
                }
            }
        })
        // Email 認證頁
        .state(STATES.MAIL_IDENTIFY,{
            url: "/invitationMail/:token",
            views: {
                'other@': {
                    templateUrl: "mobile/partials/other.html",
                    controller: 'MailIdentifyController',
                }
            }
        })
        // 企業用戶 Email 認證頁
        .state(STATES.BUSINESSMEMBER_MAIL_IDENTIFY,{
            url: "/busi-invitation-mail/:token",
            views: {
                'other@': {
                    templateUrl: "mobile/partials/other.html",
                    controller: 'BusinessMemberMailIdentifyController',
                }
            }
        })
        // Email 認證頁
        .state(STATES.CHANGE_EMAIL, {
            url: "/changeemail/:mrscid/:token",
            views: {
                'other@': {
                    templateUrl: "mobile/partials/other.html",
                    controller: 'ChangeEmailController',
                }
            }
        })

        // 重設企業用戶密碼頁面
        .state(STATES.RESET_BUSINESS_MEMBER_PASSWORD,{
            url: "/resetbmpasswd/:email/:token",
            views: {
                'other@': {
                    templateUrl: "mobile/partials/other.html",
                    controller: 'ResetBusinessMemberPasswordController',
                }
            }
        })

        .state(STATES.PAYMENT_RESULT, {
            url: "/payment-result/:orderid/:errorcode/:errordesc",
            views: {
                'full_other@': {
                    templateUrl: "mobile/partials/payment_result.html",
                    controller: 'PaymentResultController',
                }
            }
        })   

        .state(STATES.PAYMENT_SINOPACCREDITCARD, {
            url: "/payment-sinopaccreditcard/:orderid",
            views: {
                'full_other@': {
                    templateUrl: "mobile/partials/payment_sinopaccreditcard.html",
                    controller: 'PaymentSinopacCreditCardController',
                }
            }
        })        
        .state(STATES.PAYMENT_POINT, {
            url: "/payment-point/:orderid",
            views: {
                'full_other@': {
                    templateUrl: "mobile/partials/payment_point.html",
                    controller: 'PaymentPointController',
                }
            }
        })

        .state(STATES.PAYMENT_SINOPACATM, {
            url: "/payment-sinopacatm/:orderid",
            views: {
                'full_other@': {
                    templateUrl: "mobile/partials/payment_sinopacatm.html",
                    controller: 'PaymentSinopacATMController',
                }
            }
        })

        .state(STATES.PAYMENT_OUTWARDREMITTANCE, {
            url: "/payment-outwardremittance/:orderid",
            views: {
                'full_other@': {
                    templateUrl: "mobile/partials/payment_outwardremittance.html",
                    controller: 'PaymentOutwardRemittanceController',
                }
            }
        })

        .state(STATES.PAYMENT_SPGATEWAYCVS, {
            url: "/payment-spgatewaycvs/:orderid",
            views: {
                'full_other@': {
                    templateUrl: "mobile/partials/payment_spgatewaycvs.html",
                    controller: 'PaymentSpgatewayCvsController',
                }
            }
        })

        .state(STATES.PAYMENT_MONTHLY, {
            url: "/payment-monthly/:orderid",
            views: {
                'full_other@': {
                    templateUrl: "mobile/partials/payment_monthly.html",
                    controller: 'PaymentMonthlyController',
                }
            }
        })

        .state(STATES.EXTRAFEE_PAYMENT_RESULT, {
            url: "/extrafee-payment-result/:extrafeeid/:errorcode/:errordesc",
            views: {
                'full_other@': {
                    templateUrl: "mobile/partials/extrafee_payment_result.html",
                    controller: 'ExtrafeePaymentResultController',
                }
            }
        })   

        .state(STATES.EXTRAFEE_PAYMENT_SINOPACATM, {
            url: "/extrafee-payment-sinopacatm/:extrafeeid?orderid",
            views: {
                'full_other@': {
                    templateUrl: "mobile/partials/extrafee_payment_sinopacatm.html",
                    controller: 'ExtrafeePaymentSinopacATMController',
                }
            }
        })        
        .state(STATES.EXTRAFEE_PAYMENT_SINOPACCREDITCARD, {
            url: "/extrafee-payment-sinopaccreditcard/:extrafeeid?orderid",
            views: {
                'full_other@': {
                    templateUrl: "mobile/partials/extrafee_payment_sinopaccreditcard.html",
                    controller: 'ExtrafeePaymentSinopacCreditCardController',
                }
            }
        })

        .state(STATES.EXTRAFEE_PAYMENT_POINT, {
            url: "/extrafee-payment-point/:extrafeeid?orderid",
            views: {
                'full_other@': {
                    templateUrl: "mobile/partials/extrafee_payment_point.html",
                    controller: 'ExtrafeePaymentPointController',
                }
            }
        })

        .state(STATES.EXTRAFEE_PAYMENT_OUTWARDREMITTANCE, {
            url: "/extrafee-payment-outwardremittance/:extrafeeid?orderid",
            views: {
                'full_other@': {
                    templateUrl: "mobile/partials/extrafee_payment_outwardremittance.html",
                    controller: 'ExtrafeePaymentOutwardRemittanceController',
                }
            }
        })

        .state(STATES.EXTRAFEE_PAYMENT_SPGATEWAYCVS, {
            url: "/extrafee-payment-spgatewaycvs/:extrafeeid?orderid",
            views: {
                'full_other@': {
                    templateUrl: "mobile/partials/extrafee_payment_spgatewaycvs.html",
                    controller: 'ExtrafeePaymentSpgatewayCvsController',
                }
            }
        })

        .state(STATES.EXTRAFEE_PAYMENT_MONTHLY, {
            url: "/extrafee-payment-monthly/:extrafeeid?orderid",
            views: {
                'full_other@': {
                    templateUrl: "mobile/partials/extrafee_payment_monthly.html",
                    controller: 'ExtrafeePaymentMonthlyController',
                }
            }
        })

        .state(STATES.FB_LOGIN_SUCCESS, {
            url: "/fb_login_success",
            views: {
                'other@': {
                    templateUrl: "mobile/partials/fb_login_success.html",
                    controller: 'FbLoginSuccessController',
                }
            },
        });

        // .state(STATES.DESIGN_RSC, {
        //     url: "/design",
        //     views: {
        //         'design@': {
        //             templateUrl: "mobile/partials/cms_design.html",
        //             controller: 'CMSDesignController',
        //         }
        //     },

        //     deepStateRedirect: true,
        //     sticky: true
        // })

        //     .state(STATES.BLOG_LIST, {
        //         url: "/blog-list?category&sort",
        //         views: {
        //             'content@design_rsc': {
        //                 templateUrl: "mobile/partials/cms_blog_list.html",
        //                 controller: 'CMSBlogListController',
        //             }
        //         },
        //     })

        //     .state(STATES.RESOURCE_LIST, {
        //         url: "/resource-list?category&sort",
        //         views: {
        //             'content@design_rsc': {
        //                 templateUrl: "mobile/partials/cms_resource_list.html",
        //                 controller: 'CMSResuorceListController',
        //             }
        //         },
        //     })

        //     .state(STATES.DESIGNER_LIST, {
        //         url: "/designer-list?category&sort",
        //         views: {
        //             'content@design_rsc': {
        //                 templateUrl: "mobile/partials/cms_designer_list.html",
        //                 controller: 'CMSDesignerListController',
        //             }
        //         },
        //     })

        //     .state(STATES.PROJECT_LIST, {
        //         url: "/project-list?category&sort",
        //         views: {
        //             'content@design_rsc': {
        //                 templateUrl: "mobile/partials/cms_project_list.html",
        //                 controller: 'CMSProjectListController',
        //             }
        //         },
        //     })

        // .state(STATES.BLOG_POST, {
        //     url: "/blog-post/:slug",
        //     views: {
        //         'full_design@': {
        //             templateUrl: "mobile/partials/cms_blog_post.html",
        //             controller: 'CMSBlogPostController',
        //         }
        //     },
        // })

        // .state(STATES.PROJECT_POST, {
        //     url: "/project-post/:slug",
        //     views: {
        //         'full_design@': {
        //             templateUrl: "mobile/partials/cms_project_post.html",
        //             controller: 'CMSProjectPostController',
        //         }
        //     },
        // })

        // .state(STATES.DESIGNER, {
        //     url: "/designer/:slug",
        //     views: {
        //         'full_design@': {
        //             templateUrl: "mobile/partials/cms_designer.html",
        //             controller: 'CMSDesignerController',
        //         }
        //     },
        // })
    }
])

// google analytics Config
.config(['$analyticsProvider',
    function ($analyticsProvider) {

        // $analyticsProvider.virtualPageviews(false);

    }
])

.controller("RootController", ['$scope', '$state', '$timeout', '$rootScope', '$window', '$InifECGA', '$WebTitle', '$PreviousState',
	function($scope, $state, $timeout, $rootScope, $window, $InifECGA, $WebTitle, $PreviousState) {

        var isHomeView = function() {
            return $state.includes(STATES.HOME);
        }

        var isAllProductView = function() {
            return $state.includes(STATES.ALL_PRODUCT) || $state.includes(STATES.PRODUCT_LIST);
        }

        // var isProductListView = function() {

        //     switch($rootScope.state){
        //         case STATES.PRODUCT_LIST:
        //             return true;
        //         default:
        //             return false;
        //     }
        // }

        var isOrderListView = function() {
            
            return $state.includes(STATES.ORDER_LIST);
        }

        var isOtherView = function() {
            
            switch($rootScope.state){
                case STATES.OTHER:
                case STATES.ORDER_HISTORY:
                case STATES.MAIL_IDENTIFY:
                case STATES.RESET_PASSWORD:
                case STATES.CHANGE_EMAIL:
                case STATES.RESET_BUSINESS_MEMBER_PASSWORD:
                case STATES.SYSTEM_MESSAGE:
                case STATES.ABOUT:
                case STATES.CONTACT:
                case STATES.PROFILE:
                case STATES.CHANGE_PWD:
                case STATES.BUSINESSMEMBER_MAIL_IDENTIFY:
                case STATES.FB_LOGIN_SUCCESS:
                    return true;
                default:
                    return false;
            }
        }

        var isFAQView = function() {

            switch($rootScope.state) {
                case STATES.FAQ:
                    return true;
                default:
                    return false;
            }
        }

        var isFAQContentView = function() {
            
            switch($rootScope.state) {
                case STATES.FAQ_CONTENT:
                    return true;
                default:
                    return false;
            }
        }

        var isSearchView = function() {

            switch($rootScope.state){
                case STATES.SEARCH_PDT:
                case STATES.SEARCH_FAQ:
                    return true;
                default:
                    return false;
            }
        }

        var isFullOrderView = function() {
            return $state.includes(STATES.ORDER);
        }

        var isCartView = function() {
            return $state.includes(STATES.CART);
        }

        var isFullProductView = function() {

            switch($rootScope.state){
                case STATES.PRODUCT:
                case STATES.COMPLEX_PDT:
                    return true;
                default:
                    return false;
            }
        }

        var isFullOtherView = function() {

            switch($rootScope.state){
                case STATES.FAVORITE_ADDRESS:
                case STATES.BEGINNERS_GUIDE:
                case STATES.PAYMENT_RESULT:
                case STATES.PAYMENT_SINOPACCREDITCARD:
                case STATES.PAYMENT_POINT:
                case STATES.PAYMENT_SINOPACATM:
                case STATES.PAYMENT_OUTWARDREMITTANCE:
                case STATES.PAYMENT_SPGATEWAYCVS:
                case STATES.PAYMENT_MONTHLY:
                case STATES.EXTRAFEE_PAYMENT_RESULT:
                case STATES.EXTRAFEE_PAYMENT_SINOPACATM:
                case STATES.EXTRAFEE_PAYMENT_SINOPACCREDITCARD:
                case STATES.EXTRAFEE_PAYMENT_POINT:
                case STATES.EXTRAFEE_PAYMENT_OUTWARDREMITTANCE:
                case STATES.EXTRAFEE_PAYMENT_SPGATEWAYCVS:
                case STATES.EXTRAFEE_PAYMENT_MONTHLY:
                case STATES.ENTERPRISE_SIGNUP:
                case STATES.POINTS_MONTHLY_INTRODUCTION:
                    return true;
                default:
                    return false;
            }
        }

        var isDesignView = function() {

            switch($rootScope.state){
                case STATES.DESIGN_RSC:
                case STATES.BLOG_LIST:
                case STATES.RESOURCE_LIST:
                case STATES.DESIGNER_LIST:
                case STATES.PROJECT_LIST:
                    return true;
                default:
                    return false;
            }
        }

        var isFullDesignView = function() {

            switch($rootScope.state){
                case STATES.BLOG_POST:
                case STATES.PROJECT_POST:
                case STATES.DESIGNER:
                    return true;
                default:
                    return false;
            }
        }

        var isNativeLogin = function() {

            switch($rootScope.state){
                case STATES.NATIVE_LOGIN_MODAL:
                    return true;
                default:
                    return false;
            }
        }
        
        var init = function() {

        }

		//==========================
        //  Events
        //==========================
        $scope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams) {

            if(fromState.name) {
                var currentScroll = document.body.scrollTop || document.documentElement.scrollTop;
                var href = $state.href(fromState.name, fromParams);
                scrollCache[href] = currentScroll;
            }
        });

        $scope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {
                
            $rootScope.state = $state.current.name;

            if(toState.name) {
                var href = $state.href(toState.name, toParams);
                $InifECGA.pageTrack(href);

                requestAnimationFrame(function() {
                    if(scrollCache[href]) {
                        document.body.scrollTop = document.documentElement.scrollTop = scrollCache[href];
                    } else {
                        document.body.scrollTop = document.documentElement.scrollTop = 0;
                    }
                });
            }

            $PreviousState.addStataToList({
                name: toState.name,
                params: toParams
            });

            $WebTitle.changeMobileWebTitle($state.current.name);
        });

        //==========================
        //  Members
        //==========================
        var scrollCache = {};
        $rootScope.state = $state.current.name;

        //==========================
        //  Methods
        //==========================

        $scope.isHomeView = isHomeView;
        // $scope.isProductListView = isProductListView;
        $scope.isOrderListView = isOrderListView;
        $scope.isOtherView = isOtherView;
        $scope.isFAQView = isFAQView;
        $scope.isFAQContentView = isFAQContentView;
        $scope.isSearchView = isSearchView;
        $scope.isFullOrderView = isFullOrderView;
        $scope.isCartView = isCartView;
        $scope.isFullProductView = isFullProductView;
        $scope.isFullOtherView = isFullOtherView;
        $scope.isDesignView = isDesignView;
        $scope.isFullDesignView = isFullDesignView;
        $scope.isNativeLogin = isNativeLogin;
        $scope.isAllProductView = isAllProductView;

        //==========================
        //  Init
        //==========================

        init();
	}
])

.directive('spin',  ['$timeout', function($timeout){
    return {
        restrict: 'E',
        template: '<div class="spin" style="width: {{size}}; height: {{size}}; border-right-color: {{color}}; border-bottom-color: {{color}};"></div>',
        scope: {
            size: "@spinSize",
            color: "@spinColor"
        },
        link: function(scope, element, attrs, ctrls) {

            scope.size = '16px';
            scope.color = '#fff';
        }
    };
}])

.directive('mDatepicker',  ['$timeout', function($timeout){
    return {
        restrict: 'A',
        link: function(scope, element, attr){

            $(element).pickadate({
                format: 'yyyy/mm/dd',
                monthsShort: ['１月', '２月', '３月', '４月', '５月', '６月', '７月', '８月', '９月', '１０月', '１１月', '１２月'],
                weekdaysShort: ['日', '一', '二', '三', '四', '五', '六'],
                showMonthsShort: true,
                today: '今天',
                clear: '',
                close: '取消',
            });

        }
    };
}])

.directive('mTimepicker',  ['$timeout', function($timeout){
    return {
        restrict: 'A',
        link: function(scope, element, attr){

            $(element).pickatime({
                format: 'HH:i',
                formatLabel: 'HH:i',
                interval: 60,
                clear: '',
            });
        }
    };
}])

.directive('target', ['$timeout', function($timeout){
    return {
        restrict: "A",
        link: function(scope, element, attrs) {

        },
        controller : ['$scope', '$element', '$attrs', function ($scope, $element, $attrs) {

             var init = function(){

                $timeout(function() {
                    $element.off('click').off('tap').on('click tap', function(event){

                        if(window.WebViewBridge !== undefined && window.WebViewBridge.postMessage) {
                            event.stopPropagation();
                            event.preventDefault();

                            var msg = {
                                type: 'openLink',
                                link: $attrs.href,
                            }

                            msg = JSON.stringify(msg);

                            window.WebViewBridge.postMessage(msg);
                        } else if(window.WebViewBridge !== undefined && window.WebViewBridge.send) {
                            event.stopPropagation();
                            event.preventDefault();

                            var msg = {
                                type: 'openLink',
                                link: $attrs.href,
                            }

                            msg = JSON.stringify(msg);

                            window.WebViewBridge.send(msg);
                        }
                    });
                }, 500);
             }

            init();
        }]
    };
}]);

// 明確發布 main AngularJS app 給 downstream scripts 註冊使用。理由同 js/app.js。
window.InifECMobileApp = app;
